export default __webpack_public_path__ + "static/media/Logo-Icon.95ffcd78.svg";